/* eslint-disable */

import { VueInstance } from 'buefy/src/utils/config';
import { merge } from 'buefy/src/utils/helpers';
import ModernDialog from "@/components/Dialog/ModernDialog.vue";

let localVueInstance;
function open(propsData) {
  const vm = typeof window !== 'undefined' && window.Vue ? window.Vue : localVueInstance || VueInstance;
  const DialogComponent = vm.extend(ModernDialog);
  return new DialogComponent({
    el: document.createElement('div'),
    propsData,
  });
}

const Modern = {
  install(Vue) {
    localVueInstance = Vue;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$modern = {
      alert(params) {
        if (typeof params === 'string') {
          params = {
            message: params,
          };
        }
        const defaultParam = {
          canCancel: false,
        };
        const propsData = merge(defaultParam, params);
        return open(propsData);
      },
      confirm(params) {
        const defaultParam = {};
        const propsData = merge(defaultParam, params);
        return open(propsData);
      },
      prompt(params) {
        const defaultParam = {
          hasInput: true,
          confirmText: 'Done',
        };
        const propsData = merge(defaultParam, params);
        return open(propsData);
      },
    };

    Vue.prototype.$buefy.dialog = Vue.prototype.$modern;
  },
};

export default Modern;
